/**
 * The Priority badge on a call-off line or delivery line.
 *
 * One badge for every screen that lists these lines — the warehouse wizard,
 * the call-off Items tab, the supplier's ASN wizard and the haulier's call-off
 * lines — so a priority line reads the same wherever it turns up (CR-7744).
 * CR-8613: priority is ticked per call-off line in the warehouse wizard.
 */
import { Badge } from '../../ui/badge';
import { Flag } from 'lucide-react';

interface PriorityBadgeProps {
  /** Tooltip, e.g. who ticked the line and when (see `priorityTitle`). */
  title?: string;
  className?: string;
}

export default function PriorityBadge({ title, className = '' }: PriorityBadgeProps) {
  return (
    <Badge
      variant="secondary"
      title={title ?? 'Priority line'}
      className={`gap-0.5 bg-orange-200 px-1.5 py-0 text-[10px] font-semibold text-orange-900 hover:bg-orange-200 ${className}`}
    >
      <Flag className="h-2.5 w-2.5" aria-hidden="true" />
      Priority
    </Badge>
  );
}
